import React, {
  forwardRef, useRef,
} from 'react';
import PropTypes from 'prop-types';
import ErrorIcon from '../../../assets/Error.svg';
import { Typography } from '../Typography';
import './PhoneNumberInput.css';

const computeInputClassName = (inputClassName, error) => {
  const classes = [inputClassName];

  if (error) {
    classes.push('phone-number-input--error');
  }

  return classes.join(' ');
};

export const PhoneNumberInput = forwardRef(({
  wrapperClassName,
  labelClassName,
  name,
  required,
  displayLabel,
  id,
  inputClassName,
  error,
}, ref) => {
  const unusedRef = useRef();
  const inputRef = ref || unusedRef;

  const computedLabel = required ? `${displayLabel}*` : displayLabel;
  const computedInputClassName = computeInputClassName(inputClassName, error);

  return (
    <div className={wrapperClassName}>
      <label
        htmlFor={name}
        className={labelClassName}
      >
        {computedLabel}
      </label>
      <div className="phone-number-input-inner-wrapper">
        <input
          data-testid="testid-PhoneInput"
          pattern="[^a-zA-Z]{10,}"
          id={id}
          ref={inputRef}
          type="tel"
          name={name}
          className={computedInputClassName}
          required={required}
        />
        {error && (
          <div className="error-icon">
            <img alt="" src={ErrorIcon} />
          </div>
        )}
      </div>
      {error && (
        <div className="phone-number-input-error-message">
          <Typography className="error-text">
            {error}
          </Typography>
        </div>
      )}
    </div>
  );
});

PhoneNumberInput.propTypes = {
  id: PropTypes.string.isRequired,
  wrapperClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  displayLabel: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  error: PropTypes.string,
};

PhoneNumberInput.defaultProps = {
  wrapperClassName: 'phone-number-input-wrapper',
  labelClassName: 'phone-number-input-label',
  inputClassName: 'phone-number-input',
  required: false,
  error: '',
};
